import React, { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import ZbiorowyKomornikA4 from './ZbiorowyKomornikA4';
import { AdresPro2 } from '../../../../functions/ulice';

const ZbiorowyKomornikModal = props => {

    const { handleShowKomornik, showKomornik, wspolnota, mieszkancy, udzialyKontaAkt, grupy, lokale, ulice, 
        czynszeWspolnota, przelewyWspolnota, czynszeRok, przelewyRok, stawkiJednorazoweInd,
        listaMsc, idw, visible,  rok, 
         czyRok } = props;

    const componentRef = useRef();
    
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Saldo mieszkańca',
        onAfterPrint: () => console.log('Printed PDF successfully!'),
    });

    const mieszkaniec = mieszkancy?.find( m => m?.id_user == showKomornik.id_user);
    const udzialKonto = udzialyKontaAkt?.find( u => u?.id_user == showKomornik.id_user && u?.grupa_numer == showKomornik.grupa_numer);
    const adres = AdresPro2(udzialKonto, lokale, ulice, grupy);

    const [noweCzynszeWspolnota, setNoweCzynszeWspolnota] = useState([]);

    return (
        <div 
            className='rozliczenieWydruk'
            onClick={()=>{handleShowKomornik(0,0)}}
        >
            <div className='modal'>
                <div>
                    <button
                        onClick={handlePrint}
                    >
                        Drukuj
                    </button>
                </div>
                <ZbiorowyKomornikA4
                    componentRef={componentRef} 
                    showKomornik={showKomornik}
                    wspolnota={wspolnota}
                    mieszkaniec={mieszkaniec}
                    adres={adres}
                    czynszeWspolnota={czynszeWspolnota}
                    przelewyWspolnota={przelewyWspolnota}
                    stawkiJednorazoweInd={stawkiJednorazoweInd}
                    przelewyRok={przelewyRok}
                    czynszeRok={czynszeRok}
                    listaMsc={listaMsc}
                    idw={idw}
                    visible={visible}
                    rok={rok}
                    czyRok={czyRok}


                />
            </div>
        </div>
    )
}

export default ZbiorowyKomornikModal;